import * as React from 'react';
import {TextField, css} from '@sail/ui';

export const Primary = () => (
  <TextField
    label="Business name"
    placeholder="Acme Inc…"
    uses={[
      css({
        // TODO: provide these widths as tokens??
        width: css.value('168px'),
      }),
    ]}
  />
);
